import { render, staticRenderFns } from "./RegisterAgreements.vue?vue&type=template&id=370eb41c&scoped=true&"
import script from "./RegisterAgreements.vue?vue&type=script&lang=js&"
export * from "./RegisterAgreements.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAgreements.vue?vue&type=style&index=0&id=370eb41c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370eb41c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('370eb41c')) {
      api.createRecord('370eb41c', component.options)
    } else {
      api.reload('370eb41c', component.options)
    }
    module.hot.accept("./RegisterAgreements.vue?vue&type=template&id=370eb41c&scoped=true&", function () {
      api.rerender('370eb41c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/person/RegisterAgreements.vue"
export default component.exports